import { CSSProperties } from 'react';
import { styled, Theme, SxProps } from '@mui/material';

export const sxStyles: Record<string, SxProps<Theme>> = {
  wordCount: (theme: Theme) => ({
    ...(theme.typography as unknown as { body4: CSSProperties }).body4,
    color: theme.palette.text.secondary,
    position: 'absolute',
    left: '14px',
    bottom: '-24px',
    fontSize: '12px',
  }),
};

export const StyledEditorWrap = styled('div', {
  shouldForwardProp: (props) => props !== 'isFocused',
})<{ isFocused: boolean }>(({ theme, isFocused }) => ({
  position: 'relative',
  border: isFocused ? `2px solid ${theme.palette.primary.main}` : `2px solid ${theme.palette.grey['300']}`,
  borderRadius: '4px',
  margin: '1rem 0',

  '&:hover': {
    border: isFocused ? `2px solid ${theme.palette.primary.main}` : `2px solid ${theme.palette.grey['500']}`,
  },

  '& .tox': {
    border: 'none',
    borderRadius: 0,
  },

  '.tox-tbtn': {
    cursor: 'pointer',
    background: 'none !important',
  },

  '.tox-edit-area': {
    '&:before': {
      border: 'none !important',
    },
  },

  '.tox-tbtn--enabled': {
    background: `${theme.palette.grey[300]} !important`,
  },

  '& .tox .tox-editor-container .tox-editor-header': {
    backgroundColor: theme.palette.grey[100],
    boxShadow: 'none',
  },

  '& .tox .tox-toolbar-overlord>.tox-toolbar__primary': {
    backgroundColor: theme.palette.grey[100],
  },
}));
